import { useMutation } from "@tanstack/react-query";
import { chatExternalMessageService } from "@/services/chat-external-message-service";
import {
  SendExternalChatMessageRequest,
  SendExternalChatMessageResponse,
} from "@/types/chat-external-message";

export const useSendExternalMessage = () =>
  useMutation<
    SendExternalChatMessageResponse,
    unknown,
    SendExternalChatMessageRequest
  >({
    mutationFn: (payload) => chatExternalMessageService.send(payload),
  });
